import { render } from "./SidepanelAdd.vue?vue&type=template&id=5d465d94&scoped=true"
import script from "./SidepanelAdd.vue?vue&type=script&lang=js"
export * from "./SidepanelAdd.vue?vue&type=script&lang=js"

import "./SidepanelAdd.vue?vue&type=style&index=0&id=5d465d94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d465d94"]])

export default __exports__